import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../../components/ui/card';
import { Building2, Users, Target, Lightbulb } from 'lucide-react';

export default function AboutUs() {
  return (
    <div className="p-6 space-y-6" data-testid="about-us-page">
      <h1 className="text-2xl font-semibold tracking-tight">About Lockene.us</h1>

      <Card>
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <Building2 className="h-5 w-5" />
            Who We Are
          </CardTitle>
        </CardHeader>
        <CardContent className="space-y-4">
          <p className="text-muted-foreground">
            Lockene.us is a leading provider of comprehensive CRM solutions designed to empower businesses of all sizes. 
            Our platform combines powerful features with an intuitive interface to help you manage customer relationships, 
            streamline operations, and drive growth.
          </p>
          <p className="text-muted-foreground">
            Founded with a vision to make enterprise-grade CRM accessible to everyone, we've built a platform that scales 
            with your business—from startups to large enterprises.
          </p>
        </CardContent>
      </Card>

      <Card>
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <Target className="h-5 w-5" />
            Our Mission
          </CardTitle>
        </CardHeader>
        <CardContent>
          <p className="text-muted-foreground">
            To provide businesses with a powerful, flexible, and easy-to-use CRM platform that helps them build stronger 
            customer relationships, improve operational efficiency, and achieve sustainable growth.
          </p>
        </CardContent>
      </Card>

      <Card>
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <Lightbulb className="h-5 w-5" />
            Our Values
          </CardTitle>
        </CardHeader>
        <CardContent>
          <ul className="space-y-3">
            <li className="flex items-start gap-2">
              <span className="font-semibold min-w-fit">Innovation:</span>
              <span className="text-muted-foreground">We continuously evolve our platform to meet changing business needs.</span>
            </li>
            <li className="flex items-start gap-2">
              <span className="font-semibold min-w-fit">Simplicity:</span>
              <span className="text-muted-foreground">Complex features made simple through thoughtful design.</span>
            </li>
            <li className="flex items-start gap-2">
              <span className="font-semibold min-w-fit">Reliability:</span>
              <span className="text-muted-foreground">Your data is secure, and our platform is always available.</span>
            </li>
            <li className="flex items-start gap-2">
              <span className="font-semibold min-w-fit">Support:</span>
              <span className="text-muted-foreground">Dedicated customer support to help you succeed.</span>
            </li>
          </ul>
        </CardContent>
      </Card>

      <Card>
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <Users className="h-5 w-5" />
            Why Choose Us
          </CardTitle>
        </CardHeader>
        <CardContent>
          <div className="grid gap-4 md:grid-cols-2">
            <div>
              <h3 className="font-semibold mb-2">Comprehensive Features</h3>
              <p className="text-sm text-muted-foreground">
                From lead management to invoicing, we provide everything you need in one platform.
              </p>
            </div>
            <div>
              <h3 className="font-semibold mb-2">Easy Integration</h3>
              <p className="text-sm text-muted-foreground">
                Connect with your existing tools and workflows seamlessly.
              </p>
            </div>
            <div>
              <h3 className="font-semibold mb-2">Scalable Solution</h3>
              <p className="text-sm text-muted-foreground">
                Grow from 1 to 1000+ users without changing platforms.
              </p>
            </div>
            <div>
              <h3 className="font-semibold mb-2">24/7 Support</h3>
              <p className="text-sm text-muted-foreground">
                Our support team is always ready to help you succeed.
              </p>
            </div>
          </div>
        </CardContent>
      </Card>

      <Card className="bg-primary text-primary-foreground">
        <CardContent className="py-6">
          <div className="text-center">
            <h2 className="text-2xl font-bold mb-2">Ready to transform your business?</h2>
            <p className="opacity-90">Join thousands of businesses already using Lockene.us CRM</p>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
